"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
/** A TableHeader component that displays column info. */
var TableHeader = function TableHeader(_ref) {
  var numSelected = _ref.numSelected,
    _ref$onRequestSort = _ref.onRequestSort,
    onRequestSort = _ref$onRequestSort === void 0 ? function () {} : _ref$onRequestSort,
    onSelectAllClick = _ref.onSelectAllClick,
    order = _ref.order,
    orderBy = _ref.orderBy,
    rowCount = _ref.rowCount,
    _ref$headers = _ref.headers,
    headers = _ref$headers === void 0 ? [] : _ref$headers,
    checkboxCol = _ref.checkboxCol;
  var createSortHandler = function createSortHandler(e, property) {
    onRequestSort(e, property);
  };
  return /*#__PURE__*/_react["default"].createElement(_core.TableHead, null, /*#__PURE__*/_react["default"].createElement(_core.TableRow, null, checkboxCol && /*#__PURE__*/_react["default"].createElement(_core.TableCell, {
    padding: "checkbox"
  }, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
    indeterminate: numSelected && numSelected > 0 && rowCount ? numSelected < rowCount : false,
    checked: numSelected === rowCount,
    onChange: onSelectAllClick
  })), headers && headers.map(function (header) {
    return /*#__PURE__*/_react["default"].createElement(_core.TableCell, {
      key: header.id,
      align: header.numeric ? 'right' : 'left',
      padding: header.disablePadding ? 'none' : 'default',
      sortDirection: orderBy === header.id ? order : false
    }, /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
      title: "Sort",
      placement: header.numeric ? 'bottom-end' : 'bottom-start',
      enterDelay: 300
    }, /*#__PURE__*/_react["default"].createElement(_core.TableSortLabel, {
      active: orderBy === header.id,
      direction: order,
      onClick: function onClick(e) {
        return createSortHandler(e, header.id);
      }
    }, header.label)));
  })));
};
exports.TableHeader = TableHeader;